import BlockFeatureContact from './featureContact'

export default BlockFeatureContact
